/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import math from 'lodash/math'
import * as basketActions from '../../actions/components/basket'
import * as soldOutActions from '../../actions/components/soldOut'
import * as getActiveTablesActions from '../../actions/components/table'
import * as menuActions from '../../actions/components/menu'
import * as optionGroupsActions from '../../actions/components/optionGroups'
import { injectStripe } from 'react-stripe-elements'

/**
 * Import Component
 */
import Footer from '../../components/Footer'

/**
 * Declare Variable
 */
const mapStateToProps = (state, props) => {
  const orders = state.orders
  const totalOfDishsFromOrder = math.sumBy(orders, (item) => item.quantity)
  return {
    basket: state.basket,
    user: state.user,
    merchant: state.merchant,
    order: {
      list: orders,
      totalOfDishsFromOrder: totalOfDishsFromOrder,
    },
    orderHistory: state.history,
    isSwitchBottomSheet: state.isSwitchBottomSheet,
    locale: state.locale,
    currentStepIndex: state.setStep.current,
    isTakeaway: state.basket.isTakeaway,
    orders: state.orders,
    soldOut: state.soldOut,
    activeTables: state.activeTables,
    selectedTable: state.selectedTable,
  }
}
const mapDispatchToProps = (dispatch) => {
  const {
    submitBasket,
    resetOrder,
    resetStash,
    payBasket,
    requestService,
    setTakeawayOrders,
    updateSetOrderConfirmedStatus,
    createBasket,
    requestCreateBasket,
    makeWechatPayment,
    submitDineinPayment,
    getRecentPaymentInfo,
  } = bindActionCreators(basketActions, dispatch)
  const {
    updateSoldOutItems,
    updateDisplaySoldOutDialogFooter,
  } = bindActionCreators(soldOutActions, dispatch)
  const {
    getActiveTables,
  } = bindActionCreators(getActiveTablesActions, dispatch)
  const {
    resetMenusCache,
  } = bindActionCreators(menuActions, dispatch)
  const {
    resetStashByOptionGroups,
    resetStashByRadioGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)
  return {
    makeWechatPayment,
    getRecentPaymentInfo,
    submitDineinPayment,
    setTakeawayOrders,
    updateSetOrderConfirmedStatus,
    payBasket,
    submitBasket,
    resetOrder,
    resetStash,
    requestService,
    createBasket,
    updateSoldOutItems,
    updateDisplaySoldOutDialogFooter,
    getActiveTables,
    resetMenusCache,
    requestCreateBasket,
    resetStashByOptionGroups,
    resetStashByRadioGroups,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectStripe(injectIntl(Footer))))



// WEBPACK FOOTER //
// ./src/containers/components/Footer.js